import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicCircleRefundUnselected({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 56 56"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <defs>
        <circle id="pic_circle_refund_unselected_svg__a" cx={28.63} cy={28} r={28} />
      </defs>
      <g transform="translate(-.63)" fill="none" fillRule="evenodd">
        <mask id="pic_circle_refund_unselected_svg__b" fill="#fff">
          <use xlinkHref="#pic_circle_refund_unselected_svg__a" />
        </mask>
        <use fill="#999" xlinkHref="#pic_circle_refund_unselected_svg__a" />
        <g mask="url(#pic_circle_refund_unselected_svg__b)">
          <path fill="#CCC" d="M.63 42V28h15v14z" />
          <path
            d="M43.03 35c-6.26 3.83-9.81 5.87-10.67 6.12a8.35 8.35 0 01-4 .18l-7.4-1.49a7.16 7.16 0 00-2.61-.14l-1.72.2v-8.51c3.1-1.73 5.02-2.51 5.77-2.34l9.77 2.09c.68.3 1.41 2.5-.55 3.27-.42.12-.67.04-.7.03l-5.42-1.29a.86.86 0 00-1.04.6c-.11.45.17.9.63 1L30.45 36a2.42 2.42 0 002-.18c.05 0 .11 0 .17-.02l9.48-3.1a.9.9 0 00.07-.02c.29-.1.54-.07.78.08.25.15.46.43.58.76.04.12.39 1.16-.5 1.47z"
            fill="#FFF"
          />
        </g>
        <circle
          fill="#CCC"
          mask="url(#pic_circle_refund_unselected_svg__b)"
          cx={22.63}
          cy={22}
          r={4}
        />
        <circle
          fill="#FFF"
          mask="url(#pic_circle_refund_unselected_svg__b)"
          cx={32.63}
          cy={18}
          r={4}
        />
      </g>
    </svg>
  );
}

SvgPicCircleRefundUnselected.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicCircleRefundUnselected.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicCircleRefundUnselected svgRef={ref} {...props} />
));
export default ForwardRef;
